import {
    Component, Input, ChangeDetectionStrategy, OnInit, HostBinding,
} from '@angular/core';

import { PieceSeparatorStyles } from './piece-separator.models';

import { ContentItemTree } from '@features/cms-render/domain/models/contentItemTree';
import {
    CommonStylesRenderDirective,
} from '@features/cms-render/ui/directives/common-styles-render/common-styles-render.directive';

@Component({
    selector: 'piece-separator',
    templateUrl: './piece-separator.component.html',
    styleUrls: ['./piece-separator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PieceSeparatorComponent extends CommonStylesRenderDirective implements OnInit {
    @Input() public element: ContentItemTree;

    @HostBinding('style.display')
    public display: string = 'block';

    public separatorStyles: PieceSeparatorStyles;

    constructor() {
        super();
    }

    public ngOnInit(): void {
        super.setDefaultHostStyles();
        this.setupStyles();
    }

    private setupStyles(): void {
        this.separatorStyles = {
            height: this.toUnit(this.element.settings?.general?.height ?? '1pt'),
            width: this.toUnit(this.element.settings?.general?.width ?? '100%'),
            backgroundColor: this.element.settings?.general?.lineColor ?? null,
        };
    }
}
